import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { editBlog, getBlogDetails } from '../../api.controller.js';
import Swal from 'sweetalert2';
import { showNotification, showLoading } from '../../utils.ts';
import Editor from 'react-simple-wysiwyg';

function Main() {
    const { id } = useParams();
    const imageRef = useRef(null);
    const [formData, setFormData] = useState({
        title: "",
        content: "",
        author: "",
        image: null
    });
    const [imagePreview, setImagePreview] = useState(null);
    const [existingImage, setExistingImage] = useState(null);

    useEffect(() => {
        const fetchBlog = async () => {
            try {
                const response = await getBlogDetails(id);
                const blog = response.data.blog;
                setFormData({
                    title: blog.title,
                    content: blog.content,
                    author: blog.author,
                    image: null
                });
                if (blog.image) {
                    setExistingImage(`${process.env.REACT_APP_FILE_BASE_URL}/${blog.image}`);
                }
            } catch (error) {
                showNotification("Error", "Failed to load blog details", "error");
            }
        };
        fetchBlog();
    }, [id]);

    const resetBlogImage = () => {
        imageRef.current.value = null;
        setImagePreview(null);
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFormData({ ...formData, image: file });
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const _editBlog = async () => {
        const data = new FormData();
        for (const key in formData) {
            if (Object.hasOwnProperty.call(formData, key)) {
                const item = formData[key];
                // Only append image if a new one was selected
                if (key === 'image' && item === null) {
                    continue;
                }
                data.append(key, item);
            }
        }

        if (!formData.title) {
            showNotification("An Error Occurred", "Title is required", "error");
            return;
        }

        if (!formData.content) {
            showNotification("An Error Occurred", "Content is required", "error");
            return;
        }

        try {
            showLoading("Please wait", "Updating Blog");
            const response = await editBlog(id, data);
            Swal.close();
            showNotification("Great!", "Blog has been successfully updated", "success");
            
            // Update the image preview with the new image
            if (response?.image) {
                setExistingImage(`${process.env.REACT_APP_FILE_BASE_URL}/${response.image}`);
                setImagePreview(null);
            }
            
            resetBlogImage();
        } catch (error) {
            const message = error?.response?.data?.message || "An error occurred";
            showNotification("Sorry", message, "error");
            console.log(error);
        }
    };

    return (
        <div>
            <section className="contact-one pt-100 pb-100">
                <div className="container">
                    <div className="contact-one__inner">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="contact-one__content">
                                    <div className="sec-title text-@@textAlign">
                                        <h6 className="sec-title__tagline">Edit Blog</h6>
                                    </div>
                                </div>
                                <div>
                                    <form className="contact-form-validated form-one wow fadeInUp" data-wow-duration="1500ms">
                                        <div className="form-one__group">
                                            <div className="form-one__control form-one__control--full mt-3">
                                                <div>
                                                    <label>Current Image</label>
                                                </div>
                                                {existingImage && !imagePreview && (
                                                    <div className="mb-3">
                                                        <img 
                                                            src={existingImage} 
                                                            alt="Current blog" 
                                                            style={{ maxWidth: '100%', maxHeight: '300px', objectFit: 'cover' }} 
                                                        />
                                                    </div>
                                                )}
                                                {imagePreview && (
                                                    <div className="mb-3">
                                                        <img 
                                                            src={imagePreview} 
                                                            alt="New preview" 
                                                            style={{ maxWidth: '100%', maxHeight: '300px', objectFit: 'cover' }} 
                                                        />
                                                    </div>
                                                )}
                                                <div>
                                                    <label>Upload New Image</label>
                                                </div>
                                                <input 
                                                    ref={imageRef} 
                                                    onChange={handleImageChange} 
                                                    type="file" 
                                                    name="image" 
                                                    placeholder="Blog Image" 
                                                    accept="image/*"
                                                />
                                            </div>

                                            <div className="form-one__control form-one__control--full">
                                                <input type="text"
                                                    value={formData.title}
                                                    onChange={(event) => {
                                                        const title = event.target.value;
                                                        setFormData({ ...formData, title });
                                                    }}
                                                    name="title" placeholder="Title" />
                                            </div>

                                            <div className="wysiwyg-wrapper form-one__control form-one__control--full">
                                                <Editor style={{ width: "100%", height: "100%" }} placeholder="Content" value={formData.content} onChange={(e) => {
                                                    const content = e.target.value;
                                                    setFormData({ ...formData, content });
                                                }} />
                                            </div>

                                            <div className="form-one__control form-one__control--full">
                                                <button onClick={(event) => {
                                                    event.preventDefault();
                                                    _editBlog();
                                                }} type="submit" className="hiredots-btn hiredots-btn--white">
                                                    <span>Update</span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Main; 